import * as React from 'react';

/**
 * Phosphor "YoutubeLogo" — the Live Readings nav item and the "Video readings"
 * value-prop row both use it. HORO-10471.
 *
 * Path geometry is exported verbatim from Figma node 4480:13656, hence the
 * 19x19 viewBox (the desktop menu is drawn at a smaller scale than the 24x24
 * mobile frame). Display size is controlled by `.menuItemIcon`, so the viewBox
 * units don't need normalising.
 *
 * strokeWidth is deliberately NOT Figma's 0.89. The sibling menu icons
 * (Document, Clock, Plus) are 1.7 on a 24 viewBox; matching that apparent
 * weight on a 19 viewBox needs 1.7 * (19/24) ≈ 1.35. Using Figma's raw 0.89
 * would render this icon visibly thinner than the rows above it.
 */
const VideoIcon = ({ className, ...props }) => {
    return (
        <svg className={className} {...props} width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.875 9.5L8.3125 7.125V11.875L11.875 9.5Z"
                stroke="#FFFFFF"
                strokeWidth="1.35"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.78125 9.50001C1.78125 11.7199 2.0091 13.0217 2.18277 13.6911C2.2287 13.8732 2.31716 14.0418 2.44089 14.1831C2.56461 14.3244 2.72008 14.4343 2.89453 14.5038C5.38234 15.4635 9.5 15.4375 9.5 15.4375C9.5 15.4375 13.6177 15.4635 16.1055 14.5038C16.2805 14.4347 16.4365 14.3249 16.5608 14.1836C16.6851 14.0423 16.774 13.8735 16.8202 13.6911C16.9939 13.0232 17.2217 11.7199 17.2217 9.50001C17.2217 7.28013 16.9939 5.97833 16.8202 5.30888C16.7745 5.1258 16.6858 4.95624 16.5615 4.81427C16.4372 4.67229 16.2809 4.56198 16.1055 4.49247C13.6177 3.53653 9.5 3.56251 9.5 3.56251C9.5 3.56251 5.38234 3.53653 2.89453 4.49618C2.7191 4.56569 2.56276 4.676 2.43847 4.81798C2.31418 4.95995 2.2255 5.12951 2.1798 5.31259C2.0091 5.97759 1.78125 7.28013 1.78125 9.50001Z"
                stroke="#FFFFFF"
                strokeWidth="1.35"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default VideoIcon;
